import axiosClient, { unwrap } from "./axiosClient";
import { ENDPOINTS } from "./endpoints";

const cleanParams = (params = {}) =>
  Object.fromEntries(
    Object.entries(params).filter(
      ([, value]) => value !== undefined && value !== null && value !== ""
    )
  );

export const cashSettlementApi = {
  current: (businessDate) =>
    axiosClient
      .get(ENDPOINTS.cashSettlements.current, {
        params: cleanParams({ businessDate }),
      })
      .then(unwrap),

  history: ({ fromDate, toDate, businessDate } = {}) =>
    axiosClient
      .get(ENDPOINTS.cashSettlements.history, {
        params: cleanParams({ fromDate, toDate, businessDate }),
      })
      .then(unwrap),

  expenses: ({ fromDate, toDate, search, businessDate } = {}) =>
    axiosClient
      .get(ENDPOINTS.cashSettlements.expenses, {
        params: cleanParams({ fromDate, toDate, search, businessDate }),
      })
      .then(unwrap),

  addExpense: (data) =>
    axiosClient
      .post(ENDPOINTS.cashSettlements.addExpense, data)
      .then(unwrap),

  voidExpense: (expenseId, reason) =>
    axiosClient
      .post(ENDPOINTS.cashSettlements.voidExpense(expenseId), {
        reason,
      })
      .then(unwrap),

  requestSettlement: (data) =>
    axiosClient
      .post(ENDPOINTS.cashSettlements.request, data)
      .then(unwrap),

  adminList: (businessDate) =>
    axiosClient.get(ENDPOINTS.cashSettlements.adminList, {
      params: cleanParams({ businessDate }),
    }).then(unwrap),

  confirm: (settlementId, note) =>
    axiosClient
      .post(ENDPOINTS.cashSettlements.confirm(settlementId), {
        note,
      })
      .then(unwrap),

  reject: (settlementId, reason) =>
    axiosClient
      .post(ENDPOINTS.cashSettlements.reject(settlementId), {
        reason,
      })
      .then(unwrap),

  reverse: (settlementId, reason) =>
    axiosClient
      .post(ENDPOINTS.cashSettlements.reverse(settlementId), {
        reason,
      })
      .then(unwrap),
};
